import { PlayerParserResult, VIMEO_PROVIDER, YOUTUBE_PROVIDER } from 'components/Player/Player';
import urlParser from 'js-video-url-parser';

export const isAValidVideoUrl = (url: string): boolean => {
  const parsedUrl: PlayerParserResult = urlParser.parse(url);
  if (!parsedUrl || !parsedUrl.id || !parsedUrl.provider) {
    return false;
  }
  switch(parsedUrl.provider) {
    case VIMEO_PROVIDER:
    case YOUTUBE_PROVIDER:
      return true;
    default:
      return false;
  }
}